'use strict';

import { Entity } from '../Entity';

export class IndAddress extends Entity {
  protected indAddressId;
  protected indId = '0';
  protected indAddressType;
  protected indAddressStreet;
  protected indAddressUnit;
  protected indAddressCity;
  protected indAddressState;
  protected indAddressZip;
  protected indAddressCounty;
  protected indAddressDisc;
  protected indAddressPref;
  protected indAddressDnm;
  protected indAddressCommunity;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.indAddressId = data.indAddressId;
    this.indId = data.indId;
    this.indAddressType = data.indAddressType;
    this.indAddressStreet = data.indAddressStreet;
    this.indAddressUnit = data.indAddressUnit;
    this.indAddressCity = data.indAddressCity;
    this.indAddressState = data.indAddressState;
    this.indAddressZip = data.indAddressZip;
    this.indAddressCounty = data.indAddressCounty;
    this.indAddressDisc = data.indAddressDisc;
    this.indAddressPref = data.indAddressPref;
    this.indAddressDnm = data.indAddressDnm;
    this.indAddressCommunity = data.indAddressCommunity;
  }

  public getIndAddressId() {
    return this.indAddressId;
  }

  public getIndId() {
    return this.indId;
  }

  public getIndAddressType() {
    return this.indAddressType;
  }

  public setIndAddressType(indAddressType) {
    this.indAddressType = indAddressType;

    return this;
  }

  public getIndAddressStreet() {
    return this.indAddressStreet;
  }

  public setIndAddressStreet(indAddressStreet) {
    this.indAddressStreet = indAddressStreet;

    return this;
  }

  public getIndAddressUnit() {
    return this.indAddressUnit;
  }

  public setIndAddressUnit(indAddressUnit) {
    this.indAddressUnit = indAddressUnit;

    return this;
  }

  public getIndAddressCity() {
    return this.indAddressCity;
  }

  public setIndAddressCity(indAddressCity) {
    this.indAddressCity = indAddressCity;

    return this;
  }

  public getIndAddressState() {
    return this.indAddressState;
  }

  public setIndAddressState(indAddressState) {
    this.indAddressState = indAddressState;

    return this;
  }

  public getIndAddressZip() {
    return this.indAddressZip;
  }

  public setIndAddressZip(indAddressZip) {
    this.indAddressZip = indAddressZip;

    return this;
  }

  public getIndAddressCounty() {
    return this.indAddressCounty;
  }

  public setIndAddressCounty(indAddressCounty) {
    this.indAddressCounty = indAddressCounty;

    return this;
  }

  public getIndAddressDisc() {
    return this.indAddressDisc;
  }

  public getIndAddressPref() {
    return this.indAddressPref;
  }

  public getIndAddressDnm() {
    return this.indAddressDnm;
  }

  public getIndAddressCommunity() {
    return this.indAddressCommunity;
  }
}
